import { render } from "./ThemVanBan.vue?vue&type=template&id=3d4085ea&scoped=true&ts=true"
import script from "./ThemVanBan.vue?vue&type=script&lang=ts"
export * from "./ThemVanBan.vue?vue&type=script&lang=ts"

import "./ThemVanBan.vue?vue&type=style&index=0&id=3d4085ea&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/NghienCuuKhoaHoc/NCKH_FontEnd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4085ea"]])

export default __exports__